import { render, staticRenderFns } from "./BookingAccommodationForm.vue?vue&type=template&id=68c46c1c&"
import script from "./BookingAccommodationForm.vue?vue&type=script&lang=js&"
export * from "./BookingAccommodationForm.vue?vue&type=script&lang=js&"
import style0 from "./BookingAccommodationForm.vue?vue&type=style&index=0&id=68c46c1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports